import fileSys from "../fileoprators/fileSystem";
import SettingsOprator from "./settingsoprator";
const DEFAULTSET = {
  ssid: "",
  psk: "",
  enabled: false,
  mode: "auto"
};
class WifiCfg extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("wifiCfg.json"), DEFAULTSET);
  }
  getWifiSettings() {
    return this.getSettings();
  }
  saveWifiSettings(settings) {
    this.saveSettings(settings);
  }
  static init() {
    this.wifi = this.wifi || new WifiCfg();
    return this.wifi;
  }
}
export default WifiCfg.init();



// WEBPACK FOOTER //
// ./src/settings/wifiCfg.js